<template>
  <transition name="fade">
    <div v-if="animationBackground.scrolledAnimationFlag" class="LLAttentionBackground" :style="style"></div>
  </transition>
</template>

<script>
export default {
  name: 'LLAttentionBackground',
  props: {
    element: { type: null, default: null }
  },
  data() {
    return {
      animationBackground: {
        scrolledAnimationFlag: false,
        animationTimeout: null,
        blockPosition: {
          width: 100,
          height: 100
        }
      }
    }
  },
  computed: {
    style() {
      return {
        width: `${this.animationBackground.blockPosition.width + 30}px`,
        height: `${this.animationBackground.blockPosition.height + 30}px`,
        marginLeft: '-15px',
        marginTop: '-15px'
      }
    }
  },
  methods: {
    fire() {
      this.$nextTick(() => {
        this.animationBackground.blockPosition.width = this.element.offsetWidth
        this.animationBackground.blockPosition.height = this.element.offsetHeight
        this.animationBackground.scrolledAnimationFlag = true
        clearTimeout(this.animationBackground.animationTimeout)
        this.animationBackground.animationTimeout = setTimeout(() => {
          this.animationBackground.scrolledAnimationFlag = false
        }, 2000)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.LLAttentionBackground {
  @apply absolute bg-accent-03-200 top-0 left-0 w-10 h-10;

  &.fade-enter-active,
  &.fade-leave-active {
    transition: opacity 0.3s;
  }
  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
  }
}
</style>
